import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, Event, EventAddResponse } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private apiService: ApiService) {
    this.getUserPath();
  }

  getUserPath() {
    this.apiService.getUserPath();
  }

  list(): Observable<DataList<Event>> {
    return this.apiService.get<DataList<Event>>(`${this.apiService.userPath}events`).pipe();
  }

  add(code: string, event_id: number): Observable<EventAddResponse> {
    return this.apiService
      .post<EventAddResponse>(`${this.apiService.userPath}events`, { code: code, event_id: event_id })
      .pipe();
  }
}
